/**
 * Custom JavaScript hooks:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant;
 * });
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant;
 *   var quantity = event.detail.quantity;
 * });
 */

if (window.matchMedia("(max-width: 768px)").matches) {
  window.addEventListener('scroll', function() {
    var pageOffset = document.documentElement.scrollTop || document.body.scrollTop;
    var btn = document.getElementById('scrollToTop');
    if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
  }, { passive: true });
}

function parcelamento() {
  if (typeof $ === 'undefined') return;
  var precoText = $('.product-form__info-item .price--highlight').text();
  if (!precoText) return;
  var preco = precoText.split('                  ')[0].replace('R$ ', '').replace(',', '.').trim();
  var compare = $('.product-form__info-item .price--compare').text().replace('R$ ', '').replace(',', '.');
  compare = parseFloat(compare);
  if (isNaN(compare) || isNaN(parseFloat(preco))) return;
  var precompare = (compare - preco).toFixed(2).replace('.', ',');
  $('.product-label.product-label--on-sale span').text('R$ ' + precompare);
  var porcent = ((compare - preco) * 100 / compare).toFixed(2).split('.')[0];
  $('.price--highlight .product-label.product-label--on-sale').append('-' + porcent + '%');
}

if (typeof jQuery !== 'undefined') {
  jQuery(document).on('change', '.block-swatch__radio', function() {
    setTimeout(parcelamento, 150);
  });
}
